#version 300 es
/*
* Preprocessed + Optimized from './passthrough.frag'
* [Embedded string is compressed]
*/
precision mediump float;
precision highp int;

uniform mediump sampler2D uTexture;

layout(location = 0) out vec4 fragColor;
in vec2 vTextureCoord;

void main()
{
    fragColor = texture(uTexture, vTextureCoord);
}
